import { render, staticRenderFns } from "./OfertaDownSolicitudDefault.vue?vue&type=template&id=07842696&"
import script from "./OfertaDownSolicitudDefault.vue?vue&type=script&lang=js&"
export * from "./OfertaDownSolicitudDefault.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\xampp\\htdocs\\simulador_new\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('07842696')) {
      api.createRecord('07842696', component.options)
    } else {
      api.reload('07842696', component.options)
    }
    module.hot.accept("./OfertaDownSolicitudDefault.vue?vue&type=template&id=07842696&", function () {
      api.rerender('07842696', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Flujo/Ofertas/defaults/partsSolicitud/OfertaDownSolicitudDefault.vue"
export default component.exports